import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 5H16.4861C17.4732 5 18.4383 4.70781 19.2596 4.16025L21 3V18L19.2596 16.8397C18.4383 16.2922 17.4732 16 16.4861 16H8.5C5.46243 16 3 13.5376 3 10.5C3 7.46243 5.46243 5 8.5 5Z"
        className="stroke"
        strokeLinejoin="round"
      />
      <path d="M13 6H11V16H13V6Z" className="fill" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.4502 16H14.0002V21H11.3402L8.4502 16Z"
        className="stroke"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Svg;
